/**
 * usePlan2027 — TanStack Query hook for GET /api/2027-plan.
 *
 * One call populates the live V1/V2/V3 2027 pipeline+bookings plan from a single
 * Plan2027Response. Mirrors useForecast/useMainScorecard:
 *   - queryKey ['plan2027'] — one payload, no params.
 *   - staleTime 5 min — matches the sync-worker recompute cadence the baseline
 *     aggregates refresh on.
 *   - A 401 bounces via apiFetch; a 503 CACHE_NOT_READY surfaces as the amber
 *     cache-warming banner (CacheNotReadyError), exactly like the other tabs.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { Plan2027Response } from '@saledash/shared';

export function usePlan2027(): UseQueryResult<Plan2027Response> {
  return useQuery<Plan2027Response>({
    queryKey: ['plan2027'],
    queryFn: ({ signal }) => apiFetch<Plan2027Response>('/api/2027-plan', { signal }),
    staleTime: 5 * 60_000,
    retry: 2,
  });
}
